<template>
  <div class="safety-number--add">
    <form @submit.prevent="addNumber">
      <input
        type="tel"
        class="text-input"
        v-model="number"
        @keyup="validateInput"
        :placeholder="$t('safety_numbers.input_number')"
        :class="{
          'text-input__error': error,
          'text-input__success': validated && error === false,
        }"
      />
      <p
        v-if="error"
        class="error"
        v-t="'safety_numbers.input_number_in_form'"
      ></p>
      <button
        :disabled="number.length < 9 || number.length > 14"
        type="submit"
        class="button w-100 m-t-sm m-b-sm"
        v-t="'general.set'"
      ></button>
      <button
        :disabled="number.length === 0"
        class="button button--gray w-100"
        @click.prevent="cancel()"
        v-t="'general.cancel'"
      ></button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      number: '',
      validated: false,
      error: null,
      errorMsg: null,
      input: null,
    };
  },
  props: ['fafIndicator'],
  methods: {
    validateInput() {
      if (!this.validated) return;
      const input = this.number.trim().replace(' ', '');
      const isAcceptedInput = /^\+?[0-9]{9,13}$/.test(input);

      if (isAcceptedInput) {
        this.error = false;
      } else {
        this.error = true;
      }
    },
    addNumber() {
      this.validated = true;
      this.validateInput();
      if (this.error === false) {
        this.$emit('add-number', {
          fafNumber: this.number,
          fafIndicator: this.fafIndicator,
        });
        this.number = '';
      }
    },
    cancel() {
      this.number = '';
    },
  },
};
</script>

<style lang="scss">
.text-input {
  width: 100%;
  height: 44px;
  border: 1px solid $gray;
  border-radius: 4px;
  padding: 0 1rem;

  &:focus {
    outline: 0;
    box-shadow: 0 0 6px $gray;
  }

  &__wrapper {
    margin-bottom: 10px;
  }

  &__error {
    border-bottom: 4px solid red;
  }

  &__success {
    border-bottom: 4px solid green;
  }
}
</style>
